
    <fieldmagic-primary-button
      [isInProgress]="importing$ | async"
      icon="import"
      tooltip="Import From Templates"
      purpose="list-action"
      (click)="onClick()"
    >
    </fieldmagic-primary-button>
  